import { GetReceptions } from "Routes/Protected/FreezeContracts/Adapters/GetReceptions";

export const HandleFetchReceptions = (idTestimontial, setReceptions) => {
  GetReceptions(idTestimontial, setReceptions);
};
